import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the theme slice
const initialState = {
  // Set the initial night mode state based on the value stored in localStorage
  nightMode: localStorage.getItem("theme") === "dark",
};

// Create a Redux slice for handling theme-related state
const themeSlice = createSlice({
  name: "theme", // Name of the slice
  initialState, // The initial state defined above
  reducers: {
    // Reducer to toggle the night mode state
    toggleNightMode: (state) => {
      state.nightMode = !state.nightMode; // Toggle the night mode state

      // Determine the theme based on the updated night mode state
      const theme = state.nightMode ? "dark" : "light";

      // Set the data-bs-theme attribute on the document element to apply the theme
      document.documentElement.setAttribute("data-bs-theme", theme);

      // Save the updated theme preference to localStorage
      localStorage.setItem("theme", theme);
    },
    // Reducer to explicitly set the night mode state
    setNightMode: (state, action) => {
      state.nightMode = action.payload; // Update the night mode state based on the action payload

      // Determine the theme based on the updated night mode state
      const theme = state.nightMode ? "dark" : "light";

      // Set the data-bs-theme attribute on the document element to apply the theme
      document.documentElement.setAttribute("data-bs-theme", theme);

      // Save the updated theme preference to localStorage
      localStorage.setItem("theme", theme);
    },
  },
});

export const { toggleNightMode, setNightMode } = themeSlice.actions;

export default themeSlice.reducer;
